export const SITE_PILOTS_COUNT_CARD_FRENCH_LOCALE = {
  title: "Pilotes",
  subtitle: "Sur site",
  seeMore: "Voir plus",
};
